import React from 'react';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/material/styles';


export default function Accordian(props) {
  const theme = useTheme()
  return (
    <Typography component="div" sx={{ width: '100%' }}> 
          <Accordion sx={{ backgroundColor: 'transparent !important', color: theme.palette.primary.location, borderTop: '1px solid #222', boxShadow: 'none', borderRadius:'none', px:0}}>        
            <Grid container spacing="0">
              <Grid item>  
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{color:theme.palette.primary.location, fontSize:18}} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  sx={{px:0}}
                >
                  <Typography variant="span" sx={{
                    color: `${theme.palette.primary.location} !important`,                    
                    m:0, p:0
                  }}>{props.title}</Typography>
                </AccordionSummary>
              </Grid>              
            </Grid>              
            <AccordionDetails sx={{p:0}}>
              <Typography sx={{p:0}}>
                {props.data}
              </Typography>
            </AccordionDetails>                          
          </Accordion>      
    </Typography>
  );
}


